import { useEffect } from "react";
import { useLocation } from "react-router";
import { Box } from "@mui/material";
import { Form, Formik, FormikHelpers } from "formik";

import { PanelSidebar } from "components/PanelSidebar";
import { PanelDetailContent as RightContent } from "components/PanelDetailContent";
import Page from "components/wrappers/Page";
import useCatalogDetail from "hooks/useCatalogDetail";
import { ICustomPanelForm } from "types/form";

import { validationSchema } from "./index";

const SuggestedPanel = ({ customize = false }: { customize?: boolean }) => {
  const { pathname } = useLocation();
  let {
    catalog,
    customPanelAction,
    isCustomPanel,
    isSuggestedPanel,
    fetchDesignDetails,
    setCustomize,
    setIsCustomPanel,
  } = useCatalogDetail();

  useEffect(() => {
    const suggestedPanel = catalog as any;
    if (
      !!suggestedPanel &&
      Array.isArray(suggestedPanel.panelspresent) &&
      !!suggestedPanel.panelspresent.length
    ) {
      // Set new details for custom panels
      fetchDesignDetails(
        suggestedPanel.panelspresent.map((item: any) => {
          return {
            panelId: item.design,
          };
        })
      );
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [catalog?.name, fetchDesignDetails]);

  useEffect(() => {
    setCustomize(customize);
    setIsCustomPanel(true);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [pathname]);

  if (!catalog || !isSuggestedPanel || !isCustomPanel) {
    return <></>;
  }

  const onSubmit = (
    values: ICustomPanelForm,
    actions: FormikHelpers<ICustomPanelForm>
  ) => {
    customPanelAction({
      values,
      actions,
    });
  };

  return (
    <Box width={1}>
      <Formik
        initialValues={{
          panelName: customize ? "" : catalog.name || "",
          panels: [],
          ...(typeof catalog.hasMsi === "boolean" && {
            msi: catalog.hasMsi,
          }),
          ...(typeof catalog.hasMsi === "boolean" && {
            snpId: catalog.hasSnpId,
          }),
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form>
          <Page>
            <PanelSidebar />
            <RightContent />
          </Page>
        </Form>
      </Formik>
    </Box>
  );
};

export default SuggestedPanel;
